
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M0 0h20v20H0z"}}),_c('path',{attrs:{"d":"M10 1.667a8.333 8.333 0 110 16.666 8.333 8.333 0 010-16.666zm-5.511 4.29L4.459 6a6.833 6.833 0 009.74 9.39l-1.668-1.608-.057.086c-.32.445-.845.715-1.41.715h-.381l-.692-.002H9.41l-.488.002a1.733 1.733 0 01-1.492-.84 1.641 1.641 0 010-1.679l1.208-2.037L4.65 6.183a.836.836 0 01-.161-.225zM10 3.168c-1.7 0-3.254.62-4.45 1.647.104.041.2.103.283.186l1.08 1.04c.149-.265.397-.47.698-.571.415-.101.854.006 1.17.286.326.282.562.649.68 1.058.124.408.124.843 0 1.252a1.15 1.15 0 01-.13.308l.739.712.07.004c.434.042.826.286 1.046.66l.567.959 3.631 3.5A6.833 6.833 0 0010 3.167zm-3.47 5.02c.634.332 1.02.985.997 1.685a1.03 1.03 0 01-.503.862.951.951 0 01-.49.132 1.257 1.257 0 01-.536-.132 1.835 1.835 0 01-.997-1.684c.006-.353.198-.678.508-.862.318-.17.703-.17 1.02 0zm7.965 0c.308.186.497.511.503.863.015.344-.072.684-.251.98-.252.483-.746.8-1.3.836a.951.951 0 01-.467-.127 1.025 1.025 0 01-.508-.863 1.747 1.747 0 01.252-.98c.429-.717 1.202-1.026 1.771-.708zm-2.116-2.732c.405.13.716.452.825.854.106.349.12.717.045 1.072l-.045.176c-.266.853-.88 1.407-1.557 1.407-.104 0-.208-.015-.307-.045a1.235 1.235 0 01-.825-.854 2.15 2.15 0 010-1.248c.293-.971 1.104-1.561 1.864-1.362z"}})])
          )
        }
      }
    